<template lang="pug">

  .lesson-block__content.lesson-test-finish
    Header(
      v-if="content.preview"
      :title="content.preview.title"
    )

    .lesson-test-finish__title
      | Ты набрал {{content.points}} {{getNoun(content.points, 'балл', 'балла', 'баллов')}}!
    .lesson-test-finish__img(
      v-if="result.img && result.img.url"
      :style="{backgroundImage: `url('${result.img.url}')`}"
    )
    .lesson-test-finish__text.form-item__markdown(
      v-if="result.text"
      v-html="makeHtml(result.text)"
    )

</template>

<script>
import markdownToHtml from '@/functions/converterMarkdownToHtml';
import Header from './Header';

export default {
  components: { Header },
  props: ['content'],
  computed: {
    result() {
      const currentResult = this.content.results.find(interval => {
        return (
          interval.pointsFrom <= this.content.points &&
          interval.pointsTo >= this.content.points
        );
      });
      return currentResult ? currentResult : this.content.results[0];
    }
  },
  methods: {
    makeHtml(value) {
      return markdownToHtml.makeHtml(value);
    },
    getNoun(number, one, two, five) {
      let n = Math.abs(number);
      n %= 100;
      if (n >= 5 && n <= 20) {
        return five;
      }
      n %= 10;
      if (n === 1) {
        return one;
      }
      if (n >= 2 && n <= 4) {
        return two;
      }
      return five;
    }
  }
};
</script>
